<template>
  <loadingComponent v-if="isLoading" />
  <router-view/>
</template>
<script>
import {mapState} from 'vuex';
import loadingComponent from '@/components/globalLoading';
export default {
  computed:{
    ...mapState({
      isLoading:state => state.user.isLoading
    }),
  },
  components:{
    loadingComponent,
  },
  created(){
    // storage.clearAll()
  },
}
</script>
<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  font-size: 16px;
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}
</style>
